import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const aneurysm: AnswerPathTreeNode = {
  path: 'aneurysm',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAneurysmDetails }],
};
